import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CreateModal } from "../../../../shared/components/Modal";
import { useGetProduto } from "../../hooks/useGetProdutos";
import usePutProdutos from "../../hooks/usPutProduto";
import { ProdutoModulo } from "../../types/Produto";
import { TabsProduto } from "../TabsProduto";
import Swal from 'sweetalert2'

interface VisualizarProdutoProps {
  idProduto: number
  onCancel: () => void
  deleteModal: () => void
  visible: boolean
  errors: any
}

export function VisualizarProduto({ idProduto, onCancel, deleteModal, visible, errors} : VisualizarProdutoProps) {

  const { data : produtoData} = useGetProduto(idProduto)
  const [produto, setProduto] = useState<ProdutoModulo>()
  const [disabled, setDisabled] = useState<boolean>(true)
  const [loading, setIsLoading] = useState<boolean>(false)
  const {mutate : salvarEdicaoProduto} = usePutProdutos(resetForm, () => setIsLoading(false));

  const {register, handleSubmit, reset} = useForm<ProdutoModulo>({
    defaultValues: {
      Nome: produto?.Nome,
      CodigoFornecedor: produto?.CodigoFornecedor,
      TouroRaca: produto?.TouroRaca,
      TouroRack: produto?.TouroRack,
      TouroSemenTipo: produto?.TouroSemenTipo,
      ProdutoTipoId: produto?.ProdutoTipoId,
    }
  });

  function resetForm() {
    reset()
    onCancel()
    setDisabled(!disabled)
    setIsLoading(false)
  }

  useEffect(() => {
    produtoData && setProduto(produtoData)
  }, [produtoData])

  function handleHabilitaInput () {
    setDisabled(!disabled)
  }

  async function onSubmit(data : ProdutoModulo) {
    if (navigator.onLine) {
      await salvarEdicaoProduto({
        produtoAtual: produto? produto : produtoData,
        data,
        id : idProduto
      })
      setIsLoading(true)
    }

    !navigator.onLine && Swal.fire({
      title: `Sem conexão com a internet`,
      text: `Por favor, verifique a sua conexão com a internet e tente novamente.`,
      icon: "error",
      position: "center",
      confirmButtonText: "OK",
      confirmButtonColor: "#F27474",
    })
  }

  return (
    <>
      <CreateModal
        title="Visualizar de Produto"
        isModalOpen={visible}
        onCancel={onCancel}
        disabled={disabled}
        onSubmit={handleSubmit(onSubmit)}
        setDisabled={handleHabilitaInput}
        deleteOpenModal={() => {
          onCancel();
          deleteModal();
        }}
        closable
        hasId
        isLoading={loading}
      >
        <div className="min-h-[24rem] w-[50rem] mt-[-1rem] flex justify-center">
          <TabsProduto 
            produto={produto}
            inputDisabled={disabled}
            register={register}
            errors={errors}
          />
        </div>
      </CreateModal>
    </>
  );
}